module.exports = __webpack_public_path__ + "images/emoji/womans_hat.934ff33da65e0f3a620b.png";